import {
  CategoryUnionType,
  CompanySiteType,
  LinkableEntityType,
  mapCompanyLinkCategoriesType,
  mapCompanySiteType,
  mapGetPersonsListMinifiedResponseType,
  useFindCompanyLinkCategoriesSuspense,
  useFindCompanySitesSuspense,
  useFindPersonsMinifiedSuspense,
} from '@api';
import { Route } from 'src/routes/_rootLayout/companies/$id.employees';

type UseCompanyEmployeesDataReturnType = {
  sites: CompanySiteType[];
  companyLinkCategories: CategoryUnionType[];
  personsForSelect: LinkableEntityType[];
};

export const useCompanyEmployeesData =
  (): UseCompanyEmployeesDataReturnType => {
    const { id: companyId } = Route.useParams();

    const { data: sites } = useFindCompanySitesSuspense(companyId, {
      query: {
        select: (data) => data.data.map(mapCompanySiteType),
      },
    });
    const { data: companyLinkCategories } =
      useFindCompanyLinkCategoriesSuspense({
        query: {
          select: (data) => mapCompanyLinkCategoriesType(data.data),
        },
      });
    const { data: personsForSelect } = useFindPersonsMinifiedSuspense({
      query: {
        select: (data) => mapGetPersonsListMinifiedResponseType(data),
      },
    });

    return {
      sites,
      companyLinkCategories,
      personsForSelect,
    };
  };
